import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { CheckboxInput } from '../../checkbox-input';
import { IconRadioButton } from '../../icons';
import { Padding } from '../../padding';
import type { DetailCardProps } from '../types';
import { INNER_PADDING } from '../utils';
export function SelectableControl(props) {
  const $ = _c(11);
  const {
    selectableOptions,
    testId,
    disabled
  } = props;
  const t0 = !!selectableOptions?.isSelected;
  const t1 = selectableOptions?.type === "single" ? selectableOptions?.onSelect : undefined;
  let t2;
  if ($[0] !== disabled || $[1] !== selectableOptions?.indeterminate || $[2] !== selectableOptions?.isSelected || $[3] !== selectableOptions?.onSelect || $[4] !== selectableOptions?.type || $[5] !== testId) {
    t2 = selectableOptions?.type === "multiple" ? <CheckboxInput checked={selectableOptions?.isSelected} indeterminate={selectableOptions?.indeterminate} onChange={selectableOptions?.onSelect} testId={testId} disabled={disabled} /> : <IconRadioButton isActive={selectableOptions?.isSelected} testId={`${testId}-radio`} disabled={disabled} />;
    $[0] = disabled;
    $[1] = selectableOptions?.indeterminate;
    $[2] = selectableOptions?.isSelected;
    $[3] = selectableOptions?.onSelect;
    $[4] = selectableOptions?.type;
    $[5] = testId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <Padding top={INNER_PADDING}><div aria-checked={t0} aria-hidden="true" onClick={t1} role="checkbox" tabIndex={0}>{t2}</div></Padding>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}